<template>
  <v-card outlined>
    <v-data-table
      :items="list"
      :headers="headers"
      :loading="loading"
      :sort-by="['nameHierarchy']"
      :sort-desc="[false]"
      :search="filter.search"
      :items-per-page="1000"
      mobile-breakpoint="0"
    >
      <template #[`item.popularity.ranking`]="{ item }">
        <v-select
          v-if="item.popularity"
          v-model="item.popularity.id"
          :items="popularity"
          outlined
          hide-details
          item-value="id"
          item-text="name"
          class="min-width"
          dense
          @change="savePopularity(item)"
        />
      </template>
      <template #[`item.categories.length`]="{ item }">
        <v-btn
          color="info"
          text
          @click="showCategories(item)"
        >
          {{ item.categories.length }}
        </v-btn>
      </template>
      <template #[`item.publishedCount`]="{ item }">
        {{ item.publishedCount | separator }}
      </template>
      <template #[`item.notPublishedCount`]="{ item }">
        {{ item.notPublishedCount | separator }}
      </template>
      <template #[`item.actions`]="{ item }">
        <v-btn
          class="mr-2"
          outlined
          @click="rowClick(item)"
        >
          Filter
        </v-btn>
        <v-btn
          :to="`/designgroups/${item.id}`"
          class="mr-2"
        >
          Edit
        </v-btn>
      </template>
    </v-data-table>
    <Categories />
  </v-card>
</template>

<script>
import Categories from '@/components/designgroups/category/EditList';
import { mapGetters } from 'vuex';
export default {
  name: 'CatalogDesignGroups',
  components: { Categories },
  data: () => {
    return {
      headers: [
        { value: 'published' },
        { text: 'Id', value: 'id' },
        { text: 'Name', value: 'nameHierarchy' },
        { text: 'Popularity', value: 'popularity.ranking' },
        { text: 'Categories', value: 'categories.length' },
        { text: 'Published', value: 'publishedCount' },
        { text: 'Not Published', value: 'notPublishedCount' },
        { text: '', value: 'actions', sortable: false }
      ],
      loading: false
    };
  },
  computed: {
    filter: {
      get() {
        return this.$store.getters['catalog/filter'];
      },
      set(val) {
        this.$store.dispatch('catalog/filter', val);
      }
    },
    ...mapGetters({
      list: 'designgroups/list',
      filter: 'catalog/filter',
      popularity: 'lookup/popularity'
    })
  },
  mounted() {
    this.loading = true;
    Promise.all([
      this.$store.dispatch('designgroups/load', this.filter),
      this.$store.dispatch('catalog/filter', Object.assign(this.filter, { designGroupId: null }))
    ])
      .catch((error) => {
        this.logError(error);
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    rowClick(item) {
      this.$store
        .dispatch('catalog/filter', Object.assign(this.filter, { designGroupId: item.id }))
        .then(() => {
          this.$router.push({ path: '/catalog/templates' });
        });
    },
    savePopularity(item) {
      this.saving = true;
      this.$store
        .dispatch('designgroups/savePopularity', {
          id: item.id,
          popularityId: item.popularity.id
        })
        .then(() => {
          this.$root.$snackbarSuccess('Popularity saved');
        })
        .catch((error) => {
          this.logError(error);
        })
        .finally(() => {
          this.saving = false;
        });
    },
    showCategories(item) {
      this.$bus.$emit(this.$enums.EVENT_BUS_EVENTS.DESIGN_GROUP_CATEGORY_LIST_SHOW, {
        designGroupId: item.id
      });
    }
  }
};
</script>
